import React from 'react';

import {
    PlaybackSpeedButtonLabelContainer,
    PlaybackSpeedButtonLabelUnit,
} from './styles';

interface IPlaybackSpeedButtonLabelProps {
    speed: number,
}

function PlaybackSpeedButtonLabel({
    speed,
}: IPlaybackSpeedButtonLabelProps): JSX.Element {
    return (
        <PlaybackSpeedButtonLabelContainer>
            {speed}
            <PlaybackSpeedButtonLabelUnit>x</PlaybackSpeedButtonLabelUnit>
        </PlaybackSpeedButtonLabelContainer>
    );
}

export default PlaybackSpeedButtonLabel;
